import { render, staticRenderFns } from "./ModalDownload.vue?vue&type=template&id=f2019df0&"
import script from "./ModalDownload.vue?vue&type=script&lang=js&"
export * from "./ModalDownload.vue?vue&type=script&lang=js&"
import style0 from "./ModalDownload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports